export default function AJAX_Response() {
  return (
    <div>
      <h1>AJAX_Response</h1>
      <p>This is the AJAX_Response component.</p>
    </div>
  );
}